import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@eigtech/ui/components/alert-dialog'

export type JoinMeetingConfirmationModalProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  onCancel: () => void
}

export function JoinMeetingConfirmationModal({
  open,
  onOpenChange,
  onCancel,
  onConfirm,
}: JoinMeetingConfirmationModalProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>This Virtual Inspection is being recorded</AlertDialogTitle>
          <AlertDialogDescription>
            By continuing you are consenting to be recorded.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Leave</AlertDialogCancel>
          <AlertDialogAction variant="primary" onClick={onConfirm}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
